<template>
	<div class="tpl certi-edu-wrap" @click="chooseEdu=false">
		<mt-header title="学历认证" fixed>
			<router-link :to="{name:'my-certification'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
			<mt-button  slot="right" @click.native="showAlert=1">学历作用？</mt-button>
		</mt-header>
		<div class="banner">
			<img src="../../assets/img/mine/center_aut_banner2.png" alt="" />
		</div>
		<div class="upload-imgs">
			<p class="tips">请拍摄并上传你的最高学历证书</p>
			<div class="edit-options">
				<div class="upload-img">
					<div class="add-btn" v-if="previewImgUrl==''">
						<img src="../../assets/img/mine/center_aut_add.png" alt="" />
						<p>上传学历证书正面照</p>
					</div>
					<img :src="previewImgUrl"/>
					<input type="file" accept="image/*"  @change="uploads" ref="delPreview" name="img[]" class="id-imgs"/>
					<span v-if="previewImgUrl!=''" class="del-img" @click="delPreview"><img src="../../assets/img/finds/ic_sel_del@2x.png"/></span>
				</div>
				<div class="img-show">
					<img src="../../assets/img/mine/center_aut2_img.png" alt="" />
				</div>
			</div>
			<p class="tips">以上信息仅供此次认证使用，将严格保密</p>
		</div>
		<div class="other-info">
			<p><input type="text" placeholder="输入你的真实姓名" v-model="name"/></p>
			<p @click.stop="chooseEdu=true"><input readonly type="text" placeholder="选择您的最高学历" v-model="eduLevel"/><img src="../../assets/img/common/ic_arrow_enter@2x.png" alt="" /></p>
			<p><input type="text" placeholder="输入毕业院校完整名称" v-model="eduName"/></p>
		</div>
		<div class="submit-btn">
			<button @click="submitInfo">完成提交</button>
		</div>
		<transition name="fade">
			<mt-picker :slots="eduOptions" @change="setEdu" v-show="chooseEdu"></mt-picker>
		</transition>
		<common-alert v-if="showAlert" @hideAlert="hideAlert">
			<p slot="title" class="title">{{alertInfo.title}}</p>
			<div class="content" slot="content" v-html="alertInfo.text"></div>
		</common-alert>
	</div>
</template>

<script>
	import CommonAlert from "../Common/CommonAlert"
	export default{
		name:"certi-edu",
		components:{
			CommonAlert
		},
		data(){
			return{
				uid:"",
				name:"",
				eduLevel:"",
				eduName:"",
				chooseEdu:false,
				previewImgUrl:"",
				formData:new FormData(),
				showAlert:0,
				alertInfo:{
					title:"学历作用？",
					text:"<p>1：认证可以获得积分。</p><p>2：认证可以提高魅力等级，让大家更容易记住你。</p>"
				},
				
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
			
		},
		computed:{
			eduOptions() {
				let arr = ["大专以下","大专","本科","硕士","博士","海外留学"];
				let obj = [{
					flex: 1,
					values: arr,
					className: 'slot1',
					textAlign: 'center',
					defaultIndex: 2
				}, ]
				return obj;
			},
		},
		methods:{
			hideAlert(){
				this.showAlert = 0
			},
			uploads(e) {
				const file = e.target.files[0];
				let URL = window.URL || window.webkitURL;
				this.previewImgUrl = URL.createObjectURL(file);
			},
			delPreview(){
				this.$refs.delPreview.value = "";
				this.previewImgUrl = "";
			},
			submitInfo(){
				let imgs = document.querySelectorAll(".id-imgs")[0].files[0];
				this.formData.append('img[]', imgs);
				this.formData.append('uid', this.uid);
				this.formData.append('full_name', this.name);
				this.formData.append('education', this.eduLevel);
				this.formData.append('school', this.eduName);
				this.formData.append('type', 1);
				
				let config = {
		          	headers:{'Content-Type':'multipart/form-data'}
		        };
				this.$axios.post("My/AddEducationAuthentication",this.formData,config).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.$toast({
							message: res.data.msg,
							position: "bottom",
							duration: 3000
						});
						this.$router.push({
							name:"my-certification"
						})
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			setEdu(index, value) {
				this.eduLevel = value[0];
			}
		}
	}
</script>

<style scoped>
	>>>.mint-button-text{
		color: #5415F9;
	}
	.certi-edu-wrap{
		padding-top: 2.5rem;
		background: #fff;
	}
	.banner img{
		width: 100%;
		display: block;
	}
	.upload-imgs{
		background: #fff;
	}
	.upload-imgs .tips{
		font-size: 0.8rem;
		color: #5415F9;
		line-height: 1.2rem;
		background: rgba(78,5,255,0.1);
		padding: 0.4rem 1rem;
	}
	.edit-options{
		padding: 0.5rem 1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.edit-options .upload-img{
		width: 45%;
		height: 6.5rem;
		/*overflow: hidden;*/
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #f3f3f3;
		border-radius: 5px;
	}
	.edit-options .img-show{
		width: 45%;
		height: 6.5rem;
	}
	.edit-options .img-show img{
		width: 100%;
		display: block;
	}
	.edit-options .upload-img .add-btn{
	    width: 100%;
	    height: 100%;
	    background: #f3f3f3;
	    text-align: center;
	    border: 1px dotted #ccc;
	    font-size: 0.8rem;
	    color: #7b7b7b;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    flex-direction: column;
	    padding-top: 0.8rem;
	    box-sizing: border-box;
	}
	.edit-options .upload-img .add-btn img{
		width: 1.5rem;
		display: block;
		margin-bottom: 0.5rem;
	}
	.edit-options .upload-img img{
		max-width:100%;max-height:100%;
	}
	.edit-options .upload-img input{
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		opacity: 0;
	}
	.edit-options .upload-img .del-img{
		position: absolute;
		top: -0.5rem;
		right: -0.5rem;
	}
	.edit-options .upload-img .del-img img{
		width: 1.2rem;
	}
	.other-info{
		padding-top: 1rem;
		background: #f4f4f4;
	}
	.other-info p{
		border-bottom: 1px solid #f3f3f3;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		background: #fff;
	}
	.other-info p:active{
		opacity: 0.7;
	}
	.other-info p img{
		width: 1.5rem;
		margin-right: 0.5rem;
	}
	.other-info input{
		width: 100%;
		height: 2.5rem;
		padding: 0 1rem;
		border: 0;
		outline: 0;
		background: #fff;
	}
	.submit-btn{
		text-align: center;
		padding: 2rem 0;
		background: #f4f4f4;
	}
	.submit-btn button{
		width: 80%;
		height: 3rem;
		background:linear-gradient(45deg,rgba(118,68,250,1) 0%,rgba(156,124,255,1) 100%);
		border-radius:4px;
		border: 0;
		outline: 0;
		color: #fff;
	}
	.picker {
		position: fixed;
		width: 100%;
		left: 0;
		bottom: 0;
		background: #fff;
	}
	
	>>>.picker-item {
		font-size: 0.8rem;
		opacity: 0.7;
		transition: 200ms;
	}
	
	>>>.picker-item.picker-selected {
		font-size: 1rem;
		opacity: 1;
	}
	
	.edit-ivitid {
		margin-top: 3rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/CertiEdu.vue